/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Update_ErrorInputs */

const en_shipping_update_error = /** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update order`)
};

const es_shipping_update_error = /** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar el pedido`)
};

const fr_shipping_update_error = /** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la mise à jour de la commande`)
};

const de_shipping_update_error = /** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Aktualisieren der Bestellung`)
};

const id_shipping_update_error = /** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memperbarui pesanan`)
};

/** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */
const ja_shipping_update_error = en_shipping_update_error;

/** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */
const zh_shipping_update_error = en_shipping_update_error;

/** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */
const ar_shipping_update_error = en_shipping_update_error;

/** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */
const it_shipping_update_error = en_shipping_update_error;

/** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */
const ru_shipping_update_error = en_shipping_update_error;

/** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */
const pt_shipping_update_error = en_shipping_update_error;

/** @type {(inputs: Shipping_Update_ErrorInputs) => LocalizedString} */
const ko_shipping_update_error = en_shipping_update_error;

/**
* | output |
* | --- |
* | "Failed to update order" |
*
* @param {Shipping_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_update_error = /** @type {((inputs?: Shipping_Update_ErrorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Update_ErrorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_update_error(inputs)
	if (locale === "es") return es_shipping_update_error(inputs)
	if (locale === "fr") return fr_shipping_update_error(inputs)
	if (locale === "de") return de_shipping_update_error(inputs)
	if (locale === "ja") return ja_shipping_update_error(inputs)
	if (locale === "zh") return zh_shipping_update_error(inputs)
	if (locale === "ar") return ar_shipping_update_error(inputs)
	if (locale === "id") return id_shipping_update_error(inputs)
	if (locale === "it") return it_shipping_update_error(inputs)
	if (locale === "ru") return ru_shipping_update_error(inputs)
	if (locale === "pt") return pt_shipping_update_error(inputs)
	return ko_shipping_update_error(inputs)
});